module.exports = __webpack_public_path__ + "3d693e1d7037475d6d7873ba75a62875.svg";